import { filterItems } from 'common/api/v1/products';

import {
    FETCH_ITEMS,
    FETCH_ITEMS_FAILURE,
    FETCH_ITEMS_SUCCESS,
} from '../actionTypes';
import { panelsActions } from '../reducer';

export default (filterData) => (dispatch) => {
    dispatch(panelsActions[FETCH_ITEMS]());

    const {
        orderBy,
        page = 0,
        pageSize,
        searchText,
        sortBy,
    } = filterData || {};

    filterItems({
        orderBy,
        page: page + 1,
        perPage: pageSize,
        searchText,
        sortBy,
    })
        .then((response) =>
            dispatch(panelsActions[FETCH_ITEMS_SUCCESS](response.data)),
        )
        .catch((error) =>
            dispatch(
                panelsActions[FETCH_ITEMS_FAILURE](
                    error?.response?.data?.errors,
                ),
            ),
        );
};
